import { useEffect, useState } from 'react';

import { AddressInput } from '~src/components/AddressInput';
import { CalculatorFooter } from '~src/components/Footer/CalculatorFooter';
import { CalculatorHeader } from '~src/components/Header/CalculatorHeader';
import { OverlayModal } from '~src/components/Modal/OverlayModal';
import { Root } from '~src/components/Root';
import { Heading, Text } from '~src/components/Typography';
import { useBranding } from '~src/context/BrandingContext';
import { useDisplayContext } from '~src/context/DisplayContext';
import { CUSTOMER_ADDRESS, useCachedState } from '~src/hooks/useCachedState';
import { useCalculatorNavigation } from '~src/hooks/useNavigation';
import { Address, CalculatorPageProps } from '~src/model';

import { Container } from './style';
import { useLocation } from '~src/hooks/useLocation';
import { useLeadOrigin } from '~src/hooks/useLeadOrigin';

export const AddressPage = ({ standalone }: CalculatorPageProps) => {
  const [, setAddress] = useCachedState<Partial<Address>>(CUSTOMER_ADDRESS);
  const [showMask, setShowMask] = useState(false);

  const navigate = useCalculatorNavigation('address');

  const { location } = useLocation();
  const { origin: leadOrigin = 'bodil' } = useLeadOrigin();

  const { isMobile } = useDisplayContext();

  const { darkColor } = useBranding();

  const pageStyle = { paddingTop: '88px', backgroundColor: darkColor };

  const addressInputProps = {
    style: { zIndex: 10 },
    onChange: (address?: Partial<Address>) => {
      if (!isMobile) {
        setShowMask(true);
      }

      setTimeout(() => {
        setAddress(address);

        navigate('estimate');
      }, 500);
    },
  };

  const { pathname } = location;

  useEffect(() => {
    if (!pathname || pathname === '/') {
      location.href = `${location.href}${leadOrigin}/address`;
    }
  });

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        visibility: 'visible',
      }}
    >
      <Root
        header={standalone ? false : <CalculatorHeader />}
        footer={standalone ? false : <CalculatorFooter />}
        pageStyle={pageStyle}
      >
        <Container {...{ isMobile, style: { transition: 'opacity 0.5s', opacity: showMask ? 0 : 1 } }}>
          <Heading
            color='light'
            style={{
              textAlign: 'center',
              marginBottom: '24px',
            }}
          >
            Indtast din adresse nedenfor, for at starte energiberegningen
          </Heading>

          <AddressInput size='large' {...addressInputProps} />

          <Text as='p' color='light' style={{ margin: '32px 0', maxWidth: '510px', textAlign: 'center' }}>
            Med Bodils Energiberegner kan du let se hvor mange penge du kan spare med et energirigtigt hjem
          </Text>
        </Container>

        <OverlayModal visible={showMask} {...{ background: 'blurWhite', fadeIn: true }} />
      </Root>
    </div>
  );
};
